"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GunLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GunLinear = function GunLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.253 2.4c.412 0 .747.313.747.7a.66.66 0 01-.014.137l-.449 2.9c-.07.327-.38.264-.737.264L11.675 6.4c0 1.503-1.574 3.028-3.556 3.097l-.176.003c-.383 0-.753-.043-1.1-.123L5.7 12.317l-.576 1.606a.745.745 0 01-.709.477H.934c-.413 0-.748-.314-.748-.7 0-.086.017-.17.05-.25L2.29 8.433c.248-.606.019-1.292-.554-1.658l-1.41-.901a.676.676 0 01-.28-.818l.567-2.262c.142-.363.496-.372.958-.395h13.682zm-4.325 4h-1.97l.052.082a.338.338 0 01-.137.478.388.388 0 01-.51-.128L8.095 6.4h-.218L7.1 8.715c.267.055.55.085.844.085 1.672 0 2.985-1.26 2.985-2.4z",
    fill: "currentColor"
  }));
};

exports.GunLinear = GunLinear;
var _default = GunLinear;
exports.default = _default;